/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForesightScenarioFactor'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForesightScenarioFactor'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioFactorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForesightScenarioFactor);
  }
}(this, function(ApiClient, ForesightScenarioFactor) {
  'use strict';

  /**
   * ForesightScenarioFactor service.
   * @module api/ForesightScenarioFactorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForesightScenarioFactorApi. 
   * @alias module:api/ForesightScenarioFactorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the foresightScenarioFactorAddAllPut operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForesightScenarioFactor>} body 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.foresightScenarioFactorAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioFactorAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorAddPut operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioFactor} body 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.foresightScenarioFactorAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioFactorAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorDeleteAllPut operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioFactorDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioFactorDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorDeleteGet operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} factorID 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioFactorDeleteGet = function(_4SAPIAppID, factorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorDeleteGet";
      }

      // verify the required parameter 'factorID' is set
      if (factorID == undefined || factorID == null) {
        throw "Missing the required parameter 'factorID' when calling foresightScenarioFactorDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'factorID': factorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorEditPut operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioFactor} body 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioFactorEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioFactorEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorLoadGet operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForesightScenarioFactor} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} factorID 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForesightScenarioFactor}
     */
    this.foresightScenarioFactorLoadGet = function(_4SAPIAppID, factorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorLoadGet";
      }

      // verify the required parameter 'factorID' is set
      if (factorID == undefined || factorID == null) {
        throw "Missing the required parameter 'factorID' when calling foresightScenarioFactorLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'factorID': factorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForesightScenarioFactor;

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioFactorSearchPut operation.
     * @callback module:api/ForesightScenarioFactorApi~foresightScenarioFactorSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForesightScenarioFactor>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioFactor} body 
     * @param {module:api/ForesightScenarioFactorApi~foresightScenarioFactorSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForesightScenarioFactor>}
     */
    this.foresightScenarioFactorSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioFactorSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioFactorSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForesightScenarioFactor];

      return this.apiClient.callApi(
        '/ForesightScenarioFactor/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
